import { useState, useEffect } from "react";
import { api } from "@/App";
import { CloudSun, Shirt, Clock } from "lucide-react";

export default function DateCountdown({ offer }) {
  const [data, setData] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (offer?.status === "paid_pending_confirmation" && offer?.offer_id) {
      api.get(`/date-countdown/${offer.offer_id}`).then((res) => setData(res.data)).catch(() => {});
    }
  }, [offer?.offer_id, offer?.status]);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!data || !data.proposed_date) return null;
  const target = new Date(`${data.proposed_date}T${data.proposed_time || "19:00"}`).getTime();
  if (isNaN(target)) return null;
  const diff = target - now;
  if (diff < -12 * 3600 * 1000) return null;
  const past = diff <= 0;
  const abs = Math.abs(diff);
  const d = Math.floor(abs / 86400000);
  const h = Math.floor((abs % 86400000) / 3600000);
  const m = Math.floor((abs % 3600000) / 60000);
  const s = Math.floor((abs % 60000) / 1000);

  return (
    <div className="rounded-lg border border-primary/25 bg-primary/5 p-4 space-y-3 mb-3" data-testid="date-countdown">
      <div className="flex items-center gap-2 flex-wrap">
        <Clock className="w-4 h-4 text-primary" />
        <p className="text-sm font-semibold">
          {past ? "It's date time! 💫" : `Date night${data.other_name ? ` with ${data.other_name}` : ""} in`}
        </p>
        {!past && (
          <span className="font-mono text-primary font-bold text-sm" data-testid="countdown-timer">
            {d > 0 ? `${d}d ` : ""}{h}h {m}m {s}s
          </span>
        )}
      </div>

      {data.weather && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground" data-testid="countdown-weather">
          <CloudSun className="w-4 h-4 text-amber-400 shrink-0" />
          <span>
            {data.weather.summary}, {data.weather.high_f}° / {data.weather.low_f}°F
            {data.weather.precip_pct != null ? ` · ${data.weather.precip_pct}% rain` : ""}
            {data.weather.place ? ` in ${data.weather.place}` : ""}
          </span>
        </div>
      )}

      {data.outfit_tips?.length > 0 && (
        <div data-testid="countdown-outfit-tips">
          <p className="text-xs font-medium text-muted-foreground flex items-center gap-1.5 mb-1.5">
            <Shirt className="w-3.5 h-3.5 text-rose-400" /> AI stylist tips
          </p>
          <ul className="space-y-1">
            {data.outfit_tips.map((t, i) => (
              <li key={i} className="text-xs text-muted-foreground pl-3 relative before:content-['•'] before:absolute before:left-0 before:text-primary">
                {t}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
